import _classCallCheck from "/workspace/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/workspace/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.array.sort.js";
import SequentialIDGenerator from "./sequential-id-generator";
import sortMq from "./sort-css-media-queries";
export var MultiCache = /*#__PURE__*/function () {
  function MultiCache(idGenerator, onNewCache, onNewValue) {
    _classCallCheck(this, MultiCache);

    this.idGenerator = idGenerator;
    this.onNewCache = onNewCache;
    this.onNewValue = onNewValue;
    this.sortedCacheKeys = [];
    this.caches = {};
  }

  _createClass(MultiCache, [{
    key: "getCache",
    value: function getCache(key) {
      if (!this.caches[key]) {
        var cache = new Cache(this.idGenerator, this.onNewValue);
        cache.key = key;
        this.sortedCacheKeys.push(key);
        this.sortedCacheKeys.sort(sortMq);
        var keyIndex = this.sortedCacheKeys.indexOf(key);
        var insertBeforeMedia = keyIndex < this.sortedCacheKeys.length - 1 ? this.sortedCacheKeys[keyIndex + 1] : void 0;
        this.caches[key] = cache;
        this.onNewCache(key, cache, insertBeforeMedia);
      }

      return this.caches[key];
    }
  }, {
    key: "getSortedCacheKeys",
    value: function getSortedCacheKeys() {
      return this.sortedCacheKeys;
    }
  }]);

  return MultiCache;
}();
export var Cache = /*#__PURE__*/function () {
  function Cache(idGenerator, onNewValue) {
    _classCallCheck(this, Cache);

    this.cache = {};
    this.idGenerator = idGenerator;
    this.onNewValue = onNewValue;
  }

  _createClass(Cache, [{
    key: "addValue",
    value: function addValue(key, value) {
      var cached = this.cache[key];

      if (cached) {
        return cached;
      }

      var id = this.idGenerator.next();
      this.cache[key] = id;
      this.onNewValue(this, id, value);
      return id;
    }
  }]);

  return Cache;
}();